export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 7.5V20.5" stroke="#FFB82F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 4H9.5C10.8807 4 12 5.11929 12 6.5V8H9C7.89543 8 7 7.10457 7 6C7 4.89543 7.89543 4 9 4Z"
                stroke="#FFB82F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 4H14.5C13.1193 4 12 5.11929 12 6.5V8H15C16.1046 8 17 7.10457 17 6C17 4.89543 16.1046 4 15 4Z"
                stroke="#FFB82F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M5 12H19V20.52C19 20.7851 18.7851 21 18.52 21H5.48C5.2149 21 5 20.7851 5 20.52V12Z" stroke="#FFB82F" strokeWidth="1.5" />
            <rect width="18" height="4" rx="0.48" transform="matrix(1 0 0 -1 3 12)" stroke="#FFB82F" strokeWidth="1.5" />
        </svg>
    );
}
